import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';

export interface Props extends FlexProps {
  /** */
  fullWidth?: boolean;
  /** Connects any child components, when not provided they will be spaced out a little bit. */
  joined?: boolean;
}

/** Parent component to any multiples of Buttons. */
const Buttons: React.FunctionComponent<Props> = (props: Props) => {
  const { fullWidth, gap, joined, ...rest } = props;
  const classes = classnames('Buttons', {
    'Buttons--joined': joined,
  });

  return (
    <Flex { ...rest }
        className={ classes }
        direction={ fullWidth ? 'vertical' : 'horizontal' }
        gap={ joined && !fullWidth ? undefined : gap } />
  );
};

Buttons.defaultProps = {
  gap: 'x2',
};

export default Buttons;
